import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as BatteryIcon } from '../../../../../assets/images/icons/icon_battery.svg';
import { ReactComponent as InsightsIcon } from '../../../../../assets/images/icons/icon_insights.svg';
import { ReactComponent as LocationIcon } from '../../../../../assets/images/icons/icon_location.svg';
import { ReactComponent as PullResistanceIcon } from '../../../../../assets/images/icons/icon_pull_resistance.svg';
import { ReactComponent as WaterproofIcon } from '../../../../../assets/images/icons/icon_waterproof.svg';
import FeatureList from '../../../../../components/FeatureList';
import styles from './ProductFeatures.module.scss';

export default function ProductFeatures() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('key_features')}</div>
      <FeatureList
        iconRows={[
          [
            { title: t('twenty_four_seven_location_tracking'), icon: <LocationIcon /> },
            { title: t('up_to_3_month_battery_life'), icon: <BatteryIcon /> },
            { title: t('waterproof_rated_ip68'), icon: <WaterproofIcon /> },
            { title: t('activity_and_sleep_tracking'), icon: <InsightsIcon /> },
            { title: t('300lbs_pull_resistance'), icon: <PullResistanceIcon /> },
          ],
        ]}
      />
    </div>
  );
}
